function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 0.5C15.3613 0.5 7.5 8.36133 7.5 18C7.5 24.0254 10.5762 29.377 15.2344 32.5312C6.31836 36.3594 0 45.207 0 55.5H5C5 44.4258 13.9258 35.5 25 35.5C36.0742 35.5 45 44.4258 45 55.5H50C50 45.207 43.6816 36.3594 34.7656 32.5312C39.4238 29.377 42.5 24.0254 42.5 18C42.5 8.36133 34.6387 0.5 25 0.5ZM25 5.5C31.9336 5.5 37.5 11.0664 37.5 18C37.5 24.9336 31.9336 30.5 25 30.5C18.0664 30.5 12.5 24.9336 12.5 18C12.5 11.0664 18.0664 5.5 25 5.5Z",
  fill: "#CA4D30",
  fillOpacity: 0.6
});

var SvgCustomer = function SvgCustomer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Customer.98838ad5.svg";
export { ForwardRef as ReactComponent };